export const ResidentType = {
  Foreigner: 'F',
  Local: 'L',
};

export const PatientInfoEditable = {
  Editable: 'Y',
  ReadOnly: 'N',
};
